import axios from "axios";

export const API_BASE_URL = "https://myoverseas-jqx6.onrender.com";

export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});
